import { createApi } from '@reduxjs/toolkit/query/react';
import { identity, pickBy } from 'lodash';

import { API_URL } from '../../../common/constants/api-url';
import { PublisherListResponseType } from '../../../common/services/products-api.service';
import { IPublisher } from '../../../context/pages-context';
import { getBaseQuery } from '../base-query';

export const publishersApiSlice = createApi({
  baseQuery: getBaseQuery({
    baseUrl: `${API_URL}/publisher`
  }),
  endpoints: (builder) => ({
    getPublishers: builder.query<PublisherListResponseType, string>({
      query: (name) => ({
        params: pickBy({ name }, identity),
        url: '/list'
      })

    }),
    getPublisherById: builder.query<{ publisher: IPublisher }, number>({
      query: (id) => ({
        url: `/${id}`
      })

    })
  }),
  reducerPath: 'publishers'
});
